import { Component, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import Alert from 'react-bootstrap/Alert';

import { AuthenticationContext } from '../../../msal/AuthenticationContext';
import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';
import * as apiCalls from '../../../logic/apiCalls';

class ModalDeviceAddOrUpdateInternal extends Component {
    state = {
        deviceId: "",
        referenceId: "",
        description: "",
        sipExtension: "",
        sipUsername: "",
        sipPassword: "",
        groupsOptions: [],
        selectedGroupOption: null,
        iqMessengerDeviceCode: "",
        iqMessengerFallbackTimeoutSeconds: 600,
        iqMessengerConnectionOptions: [],
        selectedIqMessengerConnectionOption: null,
        eventTypeOptions: [],
        selectedEventsToNotify: [],
        successfullScan: false,
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\""; 
        let additionalCharsRegex = "!@#$%^&*()={};:";
        
        this.descriptionValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
            this.retrieveContactGroups();
            this.retrieveIqMessengerConnections();
            this.retrieveEventTypes();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        this.setState(
            {
                deviceId: isUpdate ? this.props.deviceToUpdate.deviceId : "",
                referenceId: isUpdate ? this.props.deviceToUpdate.referenceId : this.props.referenceIdToAdd,
                description: isUpdate ? this.props.deviceToUpdate.deviceDescription : "",
                sipExtension: isUpdate ? this.props.deviceToUpdate.sipExtension : "",
                sipUsername: isUpdate ? this.props.deviceToUpdate.sipUsername : "",
                sipPassword: isUpdate ? this.props.deviceToUpdate.sipPassword : "",
                iqMessengerDeviceCode: isUpdate ? this.props.deviceToUpdate.iqMessengerDeviceCode : "",
                iqMessengerFallbackTimeoutSeconds: isUpdate && this.props.deviceToUpdate.iqMessengerFallbackTimeoutSeconds ? this.props.deviceToUpdate.iqMessengerFallbackTimeoutSeconds : 600,
            }
        );
    }

    retrieveContactGroups = async () => {
        const contactGroups = await apiCalls.getContactGroups(this.props.authenticationContext);

        this.extractGroupStateFromData(contactGroups);
    }

    retrieveIqMessengerConnections = async () => {
        const connections = await apiCalls.getIqMessengerConnections(this.props.authenticationContext);

        this.extractConnectionStateFromData(connections);
    }
    
    retrieveEventTypes = async () => {
        const events = await apiCalls.getDeviceEventTypes(this.props.authenticationContext);

        this.extractEventTypesStateFromData(events);
    }

    extractGroupStateFromData = (contactGroups) => {

        var contactGroupOptions = [];
        var selectedContactGroupOption = null;

        contactGroups.forEach(contactGroup => {
            var groupFilterOption = {value:contactGroup.contactGroupId, label:contactGroup.name};
            contactGroupOptions.push(groupFilterOption);

            if (this.props.isUpdate && this.props.deviceToUpdate.contactGroupId === contactGroup.contactGroupId) {
                selectedContactGroupOption = groupFilterOption
            }
        });

        this.setState({
            groupsOptions: contactGroupOptions,
            selectedGroupOption: selectedContactGroupOption,
        });
    }

    extractConnectionStateFromData = (connections) => {

        var connectionOptions = [];
        var selectedConnectionOption = null;

        connections.forEach(connection => {
            var connectionFilterOption = {value:connection.id, label:connection.name};
            connectionOptions.push(connectionFilterOption);

            if (this.props.isUpdate && this.props.deviceToUpdate.iqMessengerConnectionId === connection.id) {
                selectedConnectionOption = connectionFilterOption
            }
        });

        this.setState({
            iqMessengerConnectionOptions: connectionOptions,
            selectedIqMessengerConnectionOption: selectedConnectionOption,
        });
    }

    extractEventTypesStateFromData = (events) => {
        var eventOptions = [];
        var selectedEventsToNotify = [];

        events.eventTypes.forEach(event => {
            var eventFilterOption = {value:event, label:event};
            eventOptions.push(eventFilterOption);

            if (!this.props.isUpdate || !this.props.deviceToUpdate.eventsToSuppress.includes(event)) {
                selectedEventsToNotify.push(eventFilterOption);
            }
        });

        this.setState({
            eventTypeOptions: eventOptions,
            selectedEventsToNotify: selectedEventsToNotify
        });
    }

    handleDoneButtonClicked = () => {
        const referenceId = this.props.referenceIdToAdd ? this.props.referenceIdToAdd : this.state.referenceId;
        const trimmedReferenceId = referenceId.trim();
        const trimmedDescription = this.state.description.trim();

        const doneInfo = {
            deviceId: this.state.deviceId,
            referenceId: trimmedReferenceId,
            description: trimmedDescription,
            eventsToSuppress: this.state.eventTypeOptions.map(et => et.value).filter(et => !this.state.selectedEventsToNotify.map(sent => sent.value).includes(et)),
            contactGroupId: this.state.selectedGroupOption?.value,
            iqMessengerDeviceCode: this.state.iqMessengerDeviceCode ? this.state.iqMessengerDeviceCode : null,
            iqMessengerFallbackTimeoutSeconds: this.state.iqMessengerFallbackTimeoutSeconds,
            iqMessengerConnectionId: this.state.selectedIqMessengerConnectionOption?.value,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleReferenceIdChanged = (e) => {
        const updatedReferenceId = e.target.value;

        if (updatedReferenceId.length > 0 && !this.descriptionValidationRegex.test(updatedReferenceId)) {
            return;
        }
                
        this.setState({
            referenceId: updatedReferenceId
        });
    }

    handleDescriptionChanged = (e) => {
        const updatedDescription = e.target.value;

        if (updatedDescription.length > 0 && !this.descriptionValidationRegex.test(updatedDescription)) {
            return;
        }
                
        this.setState({
            description: updatedDescription
        });
    }

    handleSelectedEventsToNotifyChange = (selectedEventsToNotify) => {
        if (!this.state.selectedEventsToNotify || !selectedEventsToNotify || this.state.selectedEventsToNotify.length !== selectedEventsToNotify.length || this.state.selectedEventsToNotify.some((value, index) => value.value !== selectedEventsToNotify[index].value)) {
            this.setState({
                selectedEventsToNotify: selectedEventsToNotify
            });
        }
    }

    handleSelectedGroupChange = (selectedGroupOption) => {
        if (!this.state.selectedGroupOption || !selectedGroupOption || this.state.selectedGroupOption.value !== selectedGroupOption.value) {
            this.setState(
                {
                    selectedGroupOption: selectedGroupOption
                }
            );
        }
    }

    handleIqMessengerDeviceCodeChanged = (e) => {
        const updatedDeviceCode = e.target.value;

        if (updatedDeviceCode.length > 0 && !this.descriptionValidationRegex.test(updatedDeviceCode)) {
            return;
        }
                
        this.setState({
            iqMessengerDeviceCode: updatedDeviceCode
        });
    }

    handleIqMessengerFallbackTimeoutChanged = (e) => {
        const updatedFallbackTimeoutString = e.target.value;

        if (updatedFallbackTimeoutString.length === 0)
        {
            this.setState({
                iqMessengerFallbackTimeoutSeconds: ""
            });
        }    
        else if (/^\d+$/.test(updatedFallbackTimeoutString))
        {        
            this.setState({
                iqMessengerFallbackTimeoutSeconds: parseInt(updatedFallbackTimeoutString)
            });
        }
    }

    handleSelectedConnectionChange = (selectedConnectionOption) => {
        if (!this.state.selectedIqMessengerConnectionOption || !selectedConnectionOption || this.state.selectedIqMessengerConnectionOption.value !== selectedConnectionOption.value) {
            this.setState(
                {
                    selectedIqMessengerConnectionOption: selectedConnectionOption
                }
            );
        }
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (!this.props.isUpdate && (!this.props.isSubscriptionAvailable || !this.props.islicenseAvailable)) {
            return "No license available for a new device.";
        }

        const referenceId = this.props.referenceIdToAdd ? this.props.referenceIdToAdd : this.state.referenceId;

        if (referenceId === '') {
            return "Reference ID may not be empty";
        }

        if (referenceId.length > 36) {
            return "Reference ID must be less than 36 characters";
        }

        if (this.state.description === '') {
            return "Description may not be empty";
        }

        if (this.state.description.length > 256) {
            return "Description must be less than 256 characters";
        }

        if (this.state.selectedIqMessengerConnectionOption && !this.state.iqMessengerDeviceCode)
        {
            return "Device code may not be empty when IQ messenger connection is selected";
        }

        if (this.state.iqMessengerFallbackTimeoutSeconds < 60 || this.state.iqMessengerFallbackTimeoutSeconds > 86400)
        {
            return "The fallback timeout must be between 60 and 86400 seconds";
        }

        if (!this.props.isUpdate) {
            return null;
        }

        const descriptionChanged = this.state.description !== this.props.deviceToUpdate.deviceDescription;
        const eventsToNotifyChanged = (this.state.selectedEventsToNotify ? this.state.selectedEventsToNotify.map(option => option.value) : []) !== (this.props.deviceToUpdate.eventsToNotify ? this.props.deviceToUpdate.eventsToNotify : []);
        const groupOptionChanged = (this.state.selectedGroupOption ? this.state.selectedGroupOption.value : null) !== this.props.deviceToUpdate.contactGroupId;
        const iqMessengerDeviceCodeChanged = this.state.iqMessengerDeviceCode !== this.props.deviceToUpdate.iqMessengerDeviceCode;
        const iqMessengerFallbackTimeoutChanged = this.state.iqMessengerFallbackTimeoutSeconds !== this.props.deviceToUpdate.iqMessengerFallbackTimeoutSeconds;
        const iqMessengerConnectionChanged = (this.state.selectedIqMessengerConnectionOption ? this.state.selectedIqMessengerConnectionOption.value : null) !== this.props.deviceToUpdate.iqMessengerConnectionId;

        if (descriptionChanged ||
            eventsToNotifyChanged ||
            groupOptionChanged ||
            iqMessengerDeviceCodeChanged ||
            iqMessengerFallbackTimeoutChanged ||
            iqMessengerConnectionChanged)
        {
            return null;
        }

        return "No changes detected";
    }

    render() {
        const referenceId = this.props.referenceIdToAdd ? this.props.referenceIdToAdd : this.state.referenceId;
        const headerText = this.props.isUpdate ? 'Update Device' : 'Add Device';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';
        const referenceIdDisabled = this.props.isUpdate || this.props.referenceIdToAdd ? true : false || this.state.successfullScan;

        // TODO: Fill in real Azure marketplace link.
        const licensesWarningRendered = this.props.isSubscriptionAvailable ? this.props.islicenseAvailable ? null : 
            <Alert variant='warning' style={{ opacity: 1 }}>
                Not enough licenses available to add a new device. Please increase the quantity of your subscription before adding a new device.
            </Alert> :
            <Alert variant='warning' style={{ opacity: 1 }}>
                No available subscription is found. Please go to <a href='https://azuremarketplace.microsoft.com/en-us/marketplace/apps/cybertwicebv1586872140395.cybergate'>Azure marketplace</a> to subscribe to the Zorgmessenger application.
            </Alert>;

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {licensesWarningRendered}
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newDeviceDescription">
                        <Form.Label>Reference ID</Form.Label>
                        <Form.Control type="text" placeholder="Enter reference ID" disabled={referenceIdDisabled} readonly={referenceIdDisabled} value={referenceId} autoComplete="off" onChange={this.handleReferenceIdChanged} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={this.state.description} autoComplete="off" onChange={this.handleDescriptionChanged} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceEventsToNotify">
                        <Form.Label>Events to notify</Form.Label>
                        <Select isMulti={true} value={this.state.selectedEventsToNotify} options={this.state.eventTypeOptions} onChange={this.handleSelectedEventsToNotifyChange} placeholder='Select events to notify...' />
                    </Form.Group>
                    <Form.Group controlId="newDeviceSipExtension">
                        <Form.Label>SIP Extension</Form.Label>
                        <Form.Control type="text" disabled={true} value={this.state.sipExtension} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceSipUsername">
                        <Form.Label>SIP Username</Form.Label>
                        <Form.Control type="text" disabled={true} value={this.state.sipUsername} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceSipPassword">
                        <Form.Label>SIP Password</Form.Label>
                        <Form.Control type="text" disabled={true} value={this.state.sipPassword} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceContactGroup">
                        <Form.Label>Contact Group</Form.Label>
                        <Select isSearchable={true} isClearable={true} value={this.state.selectedGroupOption} options={this.state.groupsOptions} onChange={this.handleSelectedGroupChange} placeholder='Select contact group...' />
                    </Form.Group>
                    <hr/>
                    <Form.Group controlId="newDeviceIqMessenger">
                        <h5>IQ messenger fallback (optional)</h5>                  
                        <Form.Group controlId="newDeviceDeviceCode">
                            <Form.Label>Device code</Form.Label>
                            <Form.Control type="text" placeholder="Enter device code" value={this.state.iqMessengerDeviceCode} autoComplete="off" onChange={this.handleIqMessengerDeviceCodeChanged} />
                        </Form.Group>
                        <Form.Group controlId="newDeviceFallbackTime">
                            <Form.Label>Fallback timeout (seconds)</Form.Label>
                            <Form.Control type="text" placeholder="Enter Fallback timeout" value={this.state.iqMessengerFallbackTimeoutSeconds} autoComplete="off" onChange={this.handleIqMessengerFallbackTimeoutChanged} />
                        </Form.Group>
                        <Form.Group controlId="newIqMessengerConnection">
                            <Form.Label>Connection</Form.Label>
                            <Select isSearchable={true} isClearable={true} value={this.state.selectedIqMessengerConnectionOption} options={this.state.iqMessengerConnectionOptions} onChange={this.handleSelectedConnectionChange} placeholder='Select IQ-messenger connection...' />
                        </Form.Group>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.props.onHide}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalDeviceAddOrUpdate = (props) => {
    const authenticationContext = useContext(AuthenticationContext);  

    return (
        <ModalDeviceAddOrUpdateInternal authenticationContext={authenticationContext} {...props}/>
    )
}